import Vue from 'vue';
import VueRouter from 'vue-router';
import moment from 'moment';
import routes from './routes';
import store from '../_store';
import { trackingService } from '../_services';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes,
});


router.beforeEach((to, from, next) => {
    store.dispatch('clippyNotifications/clearAll');
    // Here we track all route history
    if (store.getters['authentication/student_uuid'] !== -1) {
        trackingService.vue_router_tracks(
            store.getters['authentication/student_uuid'],
            from.name,
            from.params,
            to.name,
            to.params,
            moment().tz('America/Santiago').format('YYYY-MM-DDTHH:mm:ssZ'),
        );
    }

    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['home', 'contact form with ana', 'fuente de datos', 'sobre nosotros',
        'password_reset', 'explorar carreras'];
    const authRequired = !publicPages.includes(to.name);
    const { loggedIn } = store.state.authentication.status;
    const questionAnswered = store.state.authentication.student_data.question_answered;

    // Rules
    if (authRequired && !loggedIn) {
        return next('');
    }

    if (loggedIn && questionAnswered && to.name === 'home') {
        return next({ name: 'explorer' });
    }

    if (loggedIn && !store.getters['authentication/answered_area']
        && store.getters['authentication/checked_area']) {
        store.dispatch('authentication/logout');
        return next({ name: 'home' });
    }
    if (loggedIn && !store.getters['authentication/answered_region']
        && store.getters['authentication/checked_region']) {
        store.dispatch('authentication/logout');
        return next({ name: 'home' });
    }


    // Initial questions rules
    const InitialQuestions = ['video', 'regions', 'areas'];
    if (InitialQuestions.includes(to.name)) {
        if (!to.params.student_data) {
            return next('');
        }
        // if (to.name === 'gender' && to.params.student_data.gender) {
        //     return next({ name: 'regions', params: { student_data: to.params.student_data } });
        // }
        if (to.name === 'regions' && to.params.student_data.regions.length !== 0) {
            return next({ name: 'areas', params: { student_data: to.params.student_data } });
        }
        if (to.name === 'areas' && to.params.student_data.areas.length !== 0) {
            return next({ name: 'explorer' });
        }
    }
    if (loggedIn && !store.getters['authentication/seen_video']
        && store.getters['authentication/checked_video']
        && to.name !== 'regions') {
        store.dispatch('authentication/logout');
        return next({ name: 'home' });
    }

    return next();
});

export default router;
